import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicFiniteAutomata = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Finite Automata in TOC"
      videos={[
        "https://www.youtube.com/embed/zxMNFhqVHec",
      ]}
      takeaways={[
        { text: "Understand the formal definition and model of Finite Automata." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicFiniteAutomata };
